import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Dialog, DialogHeader, Button, Typography, DialogActions, DialogContent } from 'embeds/components';
import { styles } from './styles';

interface DialogConfirmationProps extends WithStyles<typeof styles> {
  cancelLabel?: string;
  headerIcon?: string;
  label?: string;
  onCancel: () => void;
  onSubmit: () => void;
  submitLabel?: string;
  submitDisabled?: boolean;
  title?: string;
  visible: boolean;
}

class DialogConfirmation extends React.PureComponent<DialogConfirmationProps, { submitting: boolean }> {
  // eslint-disable-line react/no-deprecated
  constructor(props: DialogConfirmationProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      submitting: false,
    };
  }

  componentWillReceiveProps(nextProps: DialogConfirmationProps) {
    const { visible } = this.props;

    if (visible !== nextProps.visible) this.setState({ submitting: false });
  }

  handleSubmit() {
    const { onSubmit } = this.props;

    this.setState({ submitting: true });
    onSubmit();
  }

  render() {
    const {
      cancelLabel,
      headerIcon,
      label,
      children,
      onCancel,
      submitLabel,
      submitDisabled,
      title,
      visible,
      classes,
    } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog fullWidth onClose={onCancel} open={visible}>
        <DialogHeader leftIcon={headerIcon || ''} title={title || 'Confirmation'} onRequestClose={onCancel} />
        <DialogContent className={classes.dialogContent}>
          {children}
          <Typography className={classes.contentLabel}>
            <div
              dangerouslySetInnerHTML={{ __html: label || '' }} // eslint-disable-line react/no-danger
            />
          </Typography>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={onCancel} color="primary" variant="text">
            {cancelLabel || 'Cancel'}
          </Button>
          {/* TODO: Change to makeStyles when we have MUI V4 */}
          <Button
            disabled={submitting || submitDisabled}
            onClick={this.handleSubmit}
            color={'primary'}
            variant="contained"
          >
            {submitLabel || 'OK'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(DialogConfirmation);
